<ng-container *appTranslate="let t">
  <div [controlRef]="formControl" [fieldConfig]="this">
    <p-message
      *ngFor="let message of props.messages"
      styleClass="mb-3"
      [severity]="message.severity"
      [text]="message.detail"
    ></p-message>

    <div *ngFor="let field of field.fieldGroup; let i = index">
      <div [class]="props.rowClass ? props.rowClass : 'flex flex-row'">
        <formly-group [field]="$any(field)">
          <small *ngIf="showError" class="p-error">
            <formly-validation-message class="ui-message-text" [field]="field"></formly-validation-message>
          </small>
        </formly-group>
        <app-button
          [removeBtnRef]="formControl"
          *ngIf="!props.readonly && formControl.enabled"
          [label]="props.removeLabel"
          [ariaLabel]="props.removeLabel ?? t('common.remove')"
          icon="pi pi-times"
          iconPos="left"
          type="button"
          class="align-self-center ml-2 repeat-remove"
          (onClick)="remove(i)"
          [disabled]="props.disabledRemoveButton"
        ></app-button>
      </div>
      <hr class="mt-0" />
    </div>

    <div class="flex justify-content-start">
      <app-button
        [addBtnRef]="formControl"
        [disabled]="props.disabledAddButton || props.readonly"
        [attr.data-testid]="'btn-add-' + props.id"
        [label]="props.addLabel"
        [ariaLabel]="props.addLabel"
        class="repeat-add"
        icon="pi pi-plus"
        iconPos="left"
        type="button"
        (onClick)="add(null, props?.defaultValue?.())"
      ></app-button>
      <app-button
        [addBtnRef]="formControl"
        class="ml-2 repeat-add"
        *ngIf="props.additionalLabel"
        [disabled]="props.disableAdditionalAddButton || props.readonly"
        [label]="props.additionalLabel"
        [ariaLabel]="props.additionalLabel"
        icon="pi pi-plus"
        type="button"
        (onClick)="add(null, to?.additionalDefaultValue?.())"
      ></app-button>
    </div>
  </div>
</ng-container>
